import { component } from 'picoapp';
import { serialize } from '@utils';

class SubscriptionForm {
  constructor(el, ctx) {
    this.ctx = ctx;
    this.el = el;
    this.identifier = el.dataset.identifier;
    this.init()
    this.bindEvents();
  }

  init() {
    this.inputs = this.el.querySelectorAll('input');
    this.successMessage = this.el.querySelector('.success_message');
  }

  bindEvents() {
    this.el.addEventListener('submit', (e) => {
      e.preventDefault();

      const formData = {}
      const consent = []
      this.inputs.forEach(i => {
        if (i.value) {
          formData[i.name] = i.value
          if (i.name.includes('phone')) {
            consent.push('sms')
            formData.sms_consent = true
          }
          if (i.name.includes('email')) {
            //consent.push('email')
          }
        }
      });
      formData['$consent'] = consent

      const options = {
        method: 'POST',
        async: true,
        crossDomain: true,
        headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'cache-control': 'no-cache' },
        body: new URLSearchParams(formData)
      };

      fetch('https://manage.kmail-lists.com/ajax/subscriptions/subscribe', options)
        .then(response => response.json())
        .then(response => {
          if (response.success) {
            this.el.querySelectorAll('.klaviyo_form_actions').forEach(el => {
              el.style.display = "none";
            })

            this.successMessage.style.display = 'block';

            if (this.identifier == 'subscribe-popup') {
              ga('send', 'event', 'Subscribe Popup', 'Subscribed');
            }
          }
        })
        .catch(err => console.error(err));
    })
  }

}

export default component((node, ctx) => {
  new SubscriptionForm(node, ctx);
});
